var map = {
	"./en/collaborators.json": 70548,
	"./en/exceptions.json": 23145,
	"./en/planning.json": 7054,
	"./en/shared.json": 16806,
	"./es/collaborators.json": 90375,
	"./es/exceptions.json": 64828,
	"./es/planning.json": 59231,
	"./es/shared.json": 66707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35689;